<template>
	<div class="dashboard-container">
		<div
			class="dashboard"
			:class="{'dashboard--loading' : loading}"
		>
			<div class="dashboard__section">
				<LayoutBox class="dashboard__card">
					<AppIcon class="icon" icon-name="apple"/>
					<div class="info">
						<h3>{{ counter.ios_count }}</h3>
						<p>iOS User</p>
					</div>
				</LayoutBox>

				<LayoutBox class="dashboard__card">
					<AppIcon class="icon" icon-name="android"/>
					<div class="info">
						<h3>{{ counter.android_count }}</h3>
						<p>Android User</p>
					</div>
				</LayoutBox>

				<LayoutBox class="dashboard__card">
					<AppIcon class="icon" icon-name="registered"/>
					<div class="info">
						<h3>{{ counter.total_registered }}</h3>
						<p>Registered User</p>
					</div>
				</LayoutBox>
			</div>

			<div class="dashboard__section">
				<LayoutBox class="dashboard__card geo-chart">
					<div
						v-if="loading"
						class="dashboard__loading"
					>
						<AppLoading/>
					</div>
					<template v-else>
						<div
							class="geo-chart__map"
						>
							User by Country
							<DashboardGeoChart
								:dataset="countries"
							/>
						</div>
						<AppTable
							class="geo-chart__table"
							:fields="fields"
							:dataset="countries"
							:checkbox="false"
							:loading="loadMoreLoading"
							@end-of-scroll="loadMore"
						>
							<template #color="{ props: { item: { color }} }">
								<span
									class="color-indicator"
									:style="`background-color: ${color}`"
								></span>
							</template>
						</AppTable>
					</template>
				</LayoutBox>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as dashboardModule from '@/store/dashboard'
import DashboardGeoChart from '@/components/dashboard/DashboardGeoChart'
export default {
	data () {
		return {
			fields: [
				{ name: 'color', text: '', style: 'width: 25px;' },
				{ name: 'country', text: 'Country' },
				{ name: 'sum(online+offline)', text: 'Users', style: 'width: 50px;' },
				{ name: 'average_emotion', text: 'Avg. Emotion' }
			]
		}
	},

	computed: {
		...mapGetters({
			counter: 'dashboard/getCounter',
			loading: 'dashboard/getDashboardLoading',
			countries: 'dashboard/getCountries',
			loadMoreLoading: 'dashboard/getChangePageLoading'
		})
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['dashboard/']) {
			this.$store.registerModule('dashboard', dashboardModule.default)
		}
	},

	created () {
		this.$store.dispatch('dashboard/getCounter')
	},

	methods: {
		loadMore (e) {
			const { current_page, last_page } = this.counter.upmood_population
			if (current_page !== last_page && !this.loadMoreLoading) {
				let url = `?page=${current_page + 1}`
				this.$store.dispatch('dashboard/loadMore', url)
			}
		}
	},

	components: {
		DashboardGeoChart
	}
}
</script>

<style lang="scss" scoped>
// avoid seting position relative on any of the block elements
// this will cause chart bubble to misalign
.dashboard-container {
	padding: 1.5em;
}

.dashboard {
	width: 100%;
	max-width: 70vw;
	min-width: 850px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	&__section {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 20px;
		overflow: hidden;
		flex-shrink: 0;

		&:last-child {
			flex: 1 0 auto;
			max-height: 34vw;
			min-height: 400px;
		}
	}

	&__card {
		flex: 1 1 auto;
		display: flex;
		align-items: center;
		padding: 20px;
		transition: 0.3s;

		&:not(:last-child) {
			margin-right: 20px;
		}

		.icon {
			width: 2.5em;
			height: 2.5em;
			padding: .5em;
			background-color: lighten($default-light, 10%);
			border-radius: 50%;
		}

		.info {
			padding: 0 20px;
		}
	}

	.geo-chart {
		overflow: hidden;
		padding: 0;
		min-height: 400px;
		height: 100%;

		&__map, &__table { height: 100%; }

		&__map {
			flex: 1 1 auto;
			border-right: 1px solid lighten($default-light, 12%);
			padding: 10px;
			font-size: 1.2em;
			display: flex;
			flex-direction: column;

			.map {
				flex: 1 1 auto;
				margin-top: 10px;
				background-color: #eee;
			}
		}

		&__table {
			padding: 10px;
			width: 300px;
			height: 100%;

			.color-indicator {
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				margin-right: 1em;
				opacity: 0.4;
			}
		}
	}

	&--loading &__card {
		> *:not(.dashboard__loading) { opacity: 0; }
		background-color: #F0F0F7;
	}

	.dashboard__loading {
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
</style>
